export const isEqual = (...objects) => objects.every(obj => JSON.stringify(obj) === JSON.stringify(objects[0]));

export const sortByAlphabetical = (field, descending = false) => {
    return (a, b) => {
        let nameA = a[field].toUpperCase();
        let nameB = b[field].toUpperCase();
        if (nameA < nameB) {
            if (descending) {
                return 1;
            }
            return -1;
        }
        if (nameA > nameB) {
            if (descending) {
                return -1;
            }
            return 1;
        }

        return 0;
    };
};

export const formatDateTime = (date) => {
    if (!date) {
        return '-';
    }
    const d = new Date(date);
    return `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}:${("0" + d.getSeconds()).slice(-2)}`;
};
